var _defs, _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayoutDashboard1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "layout-dashboard-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 5.253,
    y: 5.253,
    width: 5.25,
    height: 6.75,
    rx: 0.75,
    ry: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 5.253,
    y: 15.003,
    width: 5.25,
    height: 3.75,
    rx: 0.75,
    ry: 0.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 13.503,
    y: 12.003,
    width: 5.25,
    height: 6.75,
    rx: 0.75,
    ry: 0.75
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 13.503,
    y: 5.253,
    width: 5.25,
    height: 3.75,
    rx: 0.75,
    ry: 0.75
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.753,
    y: 0.753,
    width: 22.5,
    height: 22.5,
    rx: 1.5,
    ry: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutDashboard1);
export default __webpack_public_path__ + "static/media/layout-dashboard-1.7e348bff7ec2aadf8b805081a855d69c.svg";
export { ForwardRef as ReactComponent };